import React from "react"
import { Text, TextProps } from "@chakra-ui/react"

import useLearnPage from "@hooks/useLearnPage"

const LearnPageDescription = (props: TextProps) => {
  const { item } = useLearnPage()

  return item?.description ? (
    <Text
      size="sm"
      style={{
        display: "-webkit-box",
        WebkitLineClamp: "3",
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        marginTop: "auto",
      }}
      {...props}
    >
      {item.description}
    </Text>
  ) : (
    <></>
  )
}

export default LearnPageDescription
